// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"C_-z","disabled":"D_-z","label":"E_-z"};